define('bindingHandlers/popover2',[
    'jquery',
    'lib/lodash4',
    'lib/knockout',
    'lib/tether',

    'bindingHandlers/include'
], function (
    $,
    _,
    ko,
    Tether
    ) {
    'use strict';

    /**
     * @param name The text to be displayed in popover
     *
     * Optional
     * @param data The data to be passed into ko.i18n.renderString
     *
     * Usage: popover2: {name:'hello world'}
     */

    var TITLE_TEMPLATE_NAME   = "templates/widgets/popoverTitle";
    var CONTENT_TEMPLATE_NAME = "templates/widgets/popoverContents";
    var SHOW_DELAY = 200; //ms
    var timeoutHandle;
    var $popover = $("<div class='popover2'/>");

    Tether.position();

    var tetherHandle = new Tether({
        element: $popover,
        target: $("<div/>"),
        attachment: 'middle right',
        targetAttachment: 'middle left',
        constraints: [{
            to: 'scrollParent',
            attachment: 'together',
            pin: true
        }]
    });

    var createPopoverDiv = function(settings, allBindings, viewModel, bindingContext){
        $popover.empty();
        var $title = $("<div class='popover-title'></div>")[0];
        var $content = $("<div class='popover-content'></div>")[0];

        //Data passed to <!-- ko include: --> to render the contents of the popover, either just a string
        //    template name, or an object with a template name and data
        var includeData,
            componentClassName = '';

        if(typeof settings === "string") {
            includeData = settings;
        } else {
            includeData = {
                name: settings.name,
                data: settings.data
            };
            componentClassName = _.has(settings, 'componentClass') ? settings.componentClass : '';
        }
        $popover.addClass(componentClassName);
        $popover.append($title);

        var popoverTitleIncludeValueAccessor = ko.observable({
            name: TITLE_TEMPLATE_NAME,
            data: {
                showingBackButton: settings.showingBackButton || false,
                title: settings.title || '',
                backAction: settings.backAction || _.noop
            }
        });
        ko.bindingHandlers.include.init.call(this, $title, popoverTitleIncludeValueAccessor, allBindings, viewModel, bindingContext);
        ko.bindingHandlers.include.update.call(this, $title, popoverTitleIncludeValueAccessor, allBindings, viewModel, bindingContext);

        $popover.append($content);
        var popoverContentIncludeValueAccessor = ko.observable({
            name: CONTENT_TEMPLATE_NAME,
            data: includeData
        });
        ko.bindingHandlers.include.init.call(this, $content, popoverContentIncludeValueAccessor, allBindings, viewModel, bindingContext);
        ko.bindingHandlers.include.update.call(this, $content, popoverContentIncludeValueAccessor, allBindings, viewModel, bindingContext);
    };

    var createTetherHandle = function($element){
        var options = {
            element: $popover,
            target: $element,
            attachment: 'middle right',
            targetAttachment: 'middle left',
            constraints: [{
                to: 'window',
                attachment: 'together',
                pin: true
            }],
            offset: '0px -40px' // 30px for the width of the triangle indicator, plus 10px cushion
        };
        tetherHandle.setOptions(options);
        return tetherHandle;
    };

    var createPopover = function($element, settings, allBindings, viewModel, bindingContext){
        createPopoverDiv(settings, allBindings, viewModel, bindingContext);
        createTetherHandle($element).position();
    };

    var showPopover = function(){
        timeoutHandle = setTimeout(function(){
            tetherHandle.position();
            openPopover();
        }, SHOW_DELAY);
    };

    var openPopover = function(){
        $popover.addClass('popover-is-open');
        clearTimeout(timeoutHandle);
        timeoutHandle = null;
    };

    var closePopover = function(){
        $popover.removeClass('popover-is-open');
        tetherHandle.destroy();
    };

    var isOpen = function(){
        return $popover.hasClass('popover-is-open');
    };

    ko.bindingHandlers.popover2 = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            var settings = ko.unwrap(valueAccessor());
            var $element = $(element);

            $element.on('click.popover2', function(e){
                e.preventDefault();
                if(isOpen()){
                    closePopover();
                    if (settings.isOpen) {
                        settings.isOpen(false);
                    }
                } else {
                    createPopover($element, settings, allBindings, viewModel, bindingContext);
                    showPopover();
                    if (settings.isOpen) {
                        settings.isOpen(true);
                    }
                }
            });

            if (settings.isOpen) {
                settings.isOpen.subscribe(function () {
                    if (settings.isOpen() && !isOpen()) {
                        createPopover($element, settings, allBindings, viewModel, bindingContext);
                        showPopover();
                    } else if (!settings.isOpen() && isOpen()) {
                        closePopover();
                    }
                });
            }

            $('.popover2').on('click', '.btn-popover-close', function(e) {
                e.preventDefault();
                closePopover();
                if (settings.isOpen) {
                    settings.isOpen(false);
                }
            });

            $('.popover2').on('click', '.popover-apply-btn', function(e) {
                e.preventDefault();
                closePopover();
                if (settings.isOpen) {
                    settings.isOpen(false);
                }
            });

            ko.utils.domNodeDisposal.addDisposeCallback(element, function() {
                $element.off(".popover2");
                closePopover();
                if (settings.isOpen) {
                    settings.isOpen(false);
                }
            });
        }
    };
});

